import cabri_express_primaire from './img/Logo_Cabri_Express_primaire.svg';
import cabri_express_standard from './img/Logo_Cabri_Express_standard.svg';
import vittasciences from './img/1.png';
import imuscica from './img/2.png';
import imgActivityDefault from './img/activityDefault.jpg';
import imgLoadMore from './img/loadMore.png';

import { ReactComponent as IconApp } from './icons/icon_app.svg';
import { ReactComponent as IconDone } from './icons/icon_done.svg';
import { ReactComponent as IconLibrary } from './icons/icon_library.svg';
import { ReactComponent as IconOpensession } from './icons/icon_opensession.svg';
import { ReactComponent as IconTodo } from './icons/icon_todo.svg';
import { ReactComponent as IconUser } from './icons/icon_user.svg';
import { type FunctionComponent, type SVGProps } from 'react';

type IconComponent = FunctionComponent<SVGProps<SVGSVGElement> & { title?: string }>;

export const images: Record<string, string> = {
  'cabri_express_primaire': cabri_express_primaire,
  'cabri_express_standard': cabri_express_standard,
  'vittasciences': vittasciences,
  'imuscica': imuscica,
  'activityDefault': imgActivityDefault,
  'loadMore': imgLoadMore,
};

export const icons: Record<string, IconComponent>= {
  'applications': IconApp,
  'done': IconDone,
  'library': IconLibrary,
  'opensession': IconOpensession,
  'todo': IconTodo,
  'user': IconUser,
};